var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loadingLang)?_c('div',{class:_vm.langCode,attrs:{"id":"app"}},[_c('login-modal',{ref:"loginModal"}),_c('LegalAgreementDocument'),_c('router-view')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }